import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { mockInsights } from '../../data/mockData';
import { Insight } from '../../types';

interface InsightsState {
  items: Insight[];
  selectedFilters: string[];
  loading: boolean;
}

const initialState: InsightsState = {
  items: mockInsights,
  selectedFilters: [],
  loading: false,
};

const insightsSlice = createSlice({
  name: 'insights',
  initialState,
  reducers: {
    setSelectedFilters: (state, action: PayloadAction<string[]>) => {
      state.selectedFilters = action.payload;
    },
    addFilter: (state, action: PayloadAction<string>) => {
      if (!state.selectedFilters.includes(action.payload)) {
        state.selectedFilters.push(action.payload);
      }
    },
    removeFilter: (state, action: PayloadAction<string>) => {
      state.selectedFilters = state.selectedFilters.filter(
        filter => filter !== action.payload
      );
    },
    clearFilters: (state) => {
      state.selectedFilters = [];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    addInsight: (state, action: PayloadAction<Insight>) => {
      state.items.push(action.payload);
    },
  },
});

export const {
  setSelectedFilters,
  addFilter,
  removeFilter,
  clearFilters,
  setLoading,
  addInsight,
} = insightsSlice.actions;

export default insightsSlice.reducer;
